module.exports = __webpack_public_path__ + "static/media/Business-solution.7a295702.svg";